import RentalEditorContainer from './containers/RentalRateEditorContainer'

export default RentalEditorContainer
